import React, { useEffect, useState } from 'react';
import NavigationCollapsed from './components/navigation-collapsed';
import NavigationExpanded from './components/navigation-expanded';
import type { BreadcrumbItem } from '@drivekyte/web-components';
import { useRouter } from 'next/router';

export type NavigationProps = {
  subscriptionBreadcrumbs?: BreadcrumbItem[];
};

const MobileNavigation = ({ subscriptionBreadcrumbs }: NavigationProps) => {
  const router = useRouter();
  const [expanded, setExpanded] = useState(false);
  const handlePress = () => setExpanded((currentValue) => !currentValue);

  useEffect(() => {
    router.events.on('routeChangeComplete', () => setExpanded(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return expanded ? (
    <NavigationExpanded
      onPress={handlePress}
      isSubscription={!!subscriptionBreadcrumbs}
    />
  ) : (
    <NavigationCollapsed
      onPress={handlePress}
      subscriptionBreadcrumbs={subscriptionBreadcrumbs}
    />
  );
};

export default MobileNavigation;
